











import {Vue, Component, Emit, Prop} from "vue-property-decorator";
import {Getter, Mutation} from "vuex-class";
import axios from "axios";
import AssessmentMethodOrder from "@/valchrom/AssessmentMethodOrder";
import AmGroups from "@/valchrom/views/dataset/AmGroups.vue";

@Component({
    components: {
        AmGroups
    }
})

export default class ReportContentGenerator extends Vue {
    dataLoaded: boolean = false;
    component_url = 'experiments/datasets/';
    currentExperimentalDataset: any = {};
    overviewResponse: any;

    // map getters
    @Getter base_url !: any;
    @Getter auth_header !: any;

    @Mutation CHANGE_OVERVIEW_SIMPLIFY!: (_ : boolean) => any; //TODO: add type

    @Prop() datasetId !:number ;

    reload(){
        if(this.dataLoaded){
            this.setLoading(true);
            this.setLoading(false);
            this.waitRender(this.emitReportHtml);

        } else {
            this.loadData();
        }
    }

    @Emit('loadingState')
    emitLoadingState() {
        return !this.dataLoaded
    }

    mounted () {
        this.setLoading(true);
        this.CHANGE_OVERVIEW_SIMPLIFY(true);

        this.loadData();
    }

    private loadData() {
        let self = this;
        function loadResult(){
            axios.get(
                self.base_url + 'experiments/overview/' +
                self.datasetId + "/result",
                {
                    params: self.$route.query,
                    headers: self.auth_header,
                }
            ).then(response => {
                self.overviewResponse = response.data;
                console.log("got self.overviewResponse", self.overviewResponse);

                //sort ams by code_name
                let analytes = self.overviewResponse.analytes;
                for (let analyteId in analytes) {
                    let amGroups = analytes[analyteId].am_groups;
                    for (let amGroupId in amGroups) {
                        let amGroup = amGroups[amGroupId];
                        let ams = amGroup.ams;
                        const orderedAms = [];
                        for (let amCode in ams) {
                            let am = ams[amCode];
                            am.code = amCode;
                            orderedAms.push(am);
                        }
                        let sorter = (am1: any, am2: any) => {
                            return AssessmentMethodOrder.indexOf(am1.code_name) -
                                AssessmentMethodOrder.indexOf(am2.code_name)
                        };
                        orderedAms.sort(sorter);
                        amGroup.ams = {};
                        for (let am of orderedAms) {
                            amGroup.ams[am.code] = am
                        }
                    }
                }

                self.setLoading(false)

                self.waitRender(self.emitReportHtml);
            })
            .catch(error => {
                self.setLoading(false);
                console.log("Something went wrong getting the result", error);
            });
        }

        axios
            .get(
                this.base_url + this.component_url +
                this.datasetId,
                {
                    headers: this.auth_header,
                }
            )
            .then(response => {
                this.currentExperimentalDataset = response.data
                console.log("got this.currentExperimentalDataset", this.currentExperimentalDataset);
                loadResult()
            })
            .catch(error => {
                this.setLoading(false);
                console.log("Something went wrong getting the current Dataset", error);
            });
    }

    private setLoading(value: boolean) {
        this.dataLoaded = !value;
        this.emitLoadingState();
    }

    private waitRender(callback: ()=> void) {
        setTimeout(()=>{
            callback();
        },10);
    }

    @Emit('reportHtml')
    private emitReportHtml() {
        console.log("this.$refs.content", this.$refs.content)
        let html = (this.$refs.content as Element).innerHTML;
        return html;
    }
}
